import { Flex, SearchSelect, CreatableSearchSelect } from '@fareye/ui'
import { cancelToken, get, getQueryParams, snakeCase } from '@fareye/utils'
import React from 'react'
import { InputLabel } from '../../../../style/styled'
import { stringArrayToLabelValueArray } from '../../../../utility/funcs'
import { IApiConfig } from '../../../../utility/types'
import { IFormState } from './FilterForm'
import { ErrorMessage } from 'formik'
import { CustomErrorMessage } from '../../components/ErroMessage'

interface IMultiAttribute {
  apiConfig: IApiConfig
  model: string
  fieldValue: Array<{ attribute: any; value: any }>
  //formikProps:FormikProps<IFormState>
  index: number
  setFieldValue(field: string, value: any, shouldValidate?: boolean): void
  attribute: Array<any>
  editFlag?: boolean
}

export function MultiAttribute({
  apiConfig,
  model,
  index,
  fieldValue,
  setFieldValue,
  attribute,
  editFlag
}: IMultiAttribute) {
  const source = cancelToken().source()
  const [distinctValues, setDistinctValues] = React.useState<Array<any>>([])
  const attr = fieldValue[index].attribute
  async function fetchValues(type: string, attribute: string) {
    try {
      const { getValues } = apiConfig
      //Added check for nested attr as snakeCase function was converting '.' to '_'
      const queryParam = getQueryParams({
        type,
        attribute:
          attribute.includes('.') || attribute.includes('key')
            ? attribute
            : snakeCase(attribute),
        identifier: 'config'
      })
      const url = `${getValues.apiUrl}?${queryParam}`
      const { data } = await get(url, source.token)
      const selectData = stringArrayToLabelValueArray(data.values)
      setDistinctValues(selectData)
    } catch (ex:any) {
      setDistinctValues([])
    }
  }
  React.useEffect(() => {
    if (attr && editFlag) {
      fetchValues(model, attr.label)
    }
  }, [attr])

  return (
    <Flex mb={10} width={0.95} justifyContentSpaceBetween>
      <Flex width={1} column>
        <InputLabel>Attribute</InputLabel>
        <SearchSelect
          style={{
            wrapper: { width: '90%' }
          }}
          options={attribute}
          value={fieldValue[index].attribute}
          onChange={(ele: any) => {
            setFieldValue(`config.${index}.attribute`, ele)
            setFieldValue(`config.${index}.value`, null)
            fetchValues(model, ele.label)
          }}
          placeholder={'Select'}
        />
        <ErrorMessage
          component={CustomErrorMessage}
          name={`config.${index}.attribute`}
        />
      </Flex>
      <Flex width={1} column>
        <InputLabel>Values</InputLabel>
        <CreatableSearchSelect
          style={{
            wrapper: { width: '90%' }
          }}
          options={distinctValues}
          value={fieldValue[index].value}
          onChange={(value: any) => {
            setFieldValue(`config.${index}.value`, value)
          }}
          placeholder="Select"
          isMulti={true}
        />
        <ErrorMessage
          component={CustomErrorMessage}
          name={`config.${index}.value`}
        />
      </Flex>
    </Flex>
  )
}
